<div class="settingRow">
  <div class="optionRow">
    <div class="optionColumn" *ngFor="let turnOn of wowSettingData.turnOn">
      <label for="{{name}}_switcher_{{turnOn}}">{{turnOn ? '開啟' : '關閉'}}</label>
      <input type="radio" id="{{name}}_switcher_{{turnOn}}" name="{{name}}_switcher_{{turnOn}}" [value]="turnOn" [(ngModel)]="wowSetting.turnOn" (change)="notifyValueChange()" />
    </div>
  </div>
  
  <p>動態效果</p>
  <div class="optionRow">
    <select class="form-control" (change)="notifyValueChange()" [disabled]="!wowSetting.turnOn"
    name="{{name}}_animate" [(ngModel)]="wowSetting.animate" >
      <option *ngFor="let animate of wowSettingData.animate" [value]="animate">{{animate}}</option>
    </select>
  </div>
</div>